
<template>
    <rkm-form ref="Form">
        <box-fechamento
            v-if="loaded"
            :data="{ initials, form, model, additionals, dataAtual }"
            @handleAtualizaPaciente="handleAtualizaPaciente"
        />
    </rkm-form>
</template>

<script>
import BoxFechamento from '@/components/exame-imagem/fechamento/components/Form'

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

export default {
    components: { BoxFechamento },
    created() {

        this.repositories = {
            fechamento: this.getConectaSusRepository('exameImagem.fechamento')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        initials: {
            model: {}
        },
        form: {},
        model: {},
        additionals: {},
        idPacienteNovo: null,
        dataAtual: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.fechamento.list()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals
                    this.dataAtual = data.dataAtual;

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save(){

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.fechamento.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)

                            this.loadList()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const model = this.clone(this.model)
            return this.camelObjectKeysToSnakeRecursive(model)
        },
        loadList(){

            this.setLoading()

            this.repositories.fechamento.list()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals
                })
                .finally(() => this.unsetLoading())
        },
        handleAtualizaPaciente(value){

            this.idPacienteNovo = value

            this.$emit('handleAtualizaLancamento', this.idPacienteNovo)
        }
    },
    mixins: [repository, error, object, data, stringCase]
}
</script>